/** Aggregated revenue + occupancy totals across all branches (ML-04). */
import type { types } from '@gym/shared';
import { Building2, CalendarCheck, TrendingUp, Users } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { EmptyState, KpiCard, Money, useFormatters } from '../../components/ui.js';

export function CrossBranchStats({
  totals,
}: {
  totals: types.MultiLocationSummary['totals'];
}): ReactNode {
  const { t } = useTranslation();
  const fmt = useFormatters();

  if (totals.locations_count === 0) {
    return <EmptyState icon={Building2} title={t('multilocation.empty')} />;
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <KpiCard
        label={t('multilocation.totalRevenue')}
        value={<Money minor={totals.gross_revenue} className="text-3xl" />}
        icon={TrendingUp}
        tone="success"
      />
      <KpiCard
        label={t('multilocation.totalOccupancy')}
        value={fmt.number(totals.live_occupancy)}
        icon={Users}
        tone="primary"
      />
      <KpiCard
        label={t('multilocation.totalCheckins')}
        value={fmt.number(totals.checkins_today)}
        icon={CalendarCheck}
        tone="info"
      />
      <KpiCard
        label={t('multilocation.branches')}
        value={fmt.number(totals.locations_count)}
        icon={Building2}
        tone="warning"
      />
    </div>
  );
}
